// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"f2d0057d","368":"aa095315","453":"0098adef","738":"002f5735","746":"76c7384b","974":"74ca8005"}[chunkId] + ".chunk.js";
};